import { LOGIN, LOGOUT, UPDATE_USER } from "../constants/";

const authDefaultState = {
  user: {},
};

const authReducer = (state = authDefaultState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        user: action.payload,
      };
    case UPDATE_USER: {
      const user = state.user;
      if (user._id === action.payload.userId) {
        user.companyId = action.payload.companyId;

        return {
          ...state,
          user,
        };
      }
      return state;
    }
    case LOGOUT:
      return {
        ...state,
        user: {},
      };
    default:
      return state;
  }
};
export default authReducer;
